// extracted by mini-css-extract-plugin
module.exports = {"addWrap":"Config_addWrap__LpUIy","addNew__icon":"Config_addNew__icon__eLLKG","addNew__text":"Config_addNew__text__27vrE","goBack__icon":"Config_goBack__icon__22iBR"};